<div class="menu-container">
  <div class="loaded">
    <div class="banner-bg">
      <div class="flex-container">
        <!--<div class="angle-left">
        <ion-button *ngIf="containers?.length > 6" (click)="scrollRight()" [disabled]="page === 1"
          class="ion-no-padding ion-no-margin" color="none"
          fill="clear">
          <ion-icon name="chevron-back-circle-outline"></ion-icon>
        </ion-button>
      </div>-->
        <div class="stays" #menuItemsContainer>
          @if (containers?.length > 0; ) {
            @for (container of containers; track container; let index = $index) {
              @if (container?.isActive) {
                <div [routerLink]="container?.navigationURL"
                     class="stay-img"
                     (click)="onSelectTab(container)"
                     [ngClass]="{'active': selectedContainer?.key === container.key}">
                  @if (container?.key | menuKeyChecker; as menuClass) {
                    <div class="property-img" [ngClass]="{ 'deactivate-menu': !container?.isActive }">
                      <div class="menu-img {{ menuClass }}">
                        <div class="n-cls">New</div>
                        <div class="ai-cls">Bag2Bag AI</div>
                      </div>
                    </div>
                  }
                  <div class="title">
                    <div class="stay-name">{{ container.title }}</div>
                  </div>
                </div>
              }
            }
          }
        </div>
        <!--<div class="angle-right">
        <ion-button
          *ngIf="containers?.length > 6"
          (click)="scrollLeft()"
          [disabled]="page === totalPages"
          class="ion-no-padding ion-no-margin"
          color="none"
          fill="clear"
          >
          <ion-icon name="chevron-forward-circle-outline"></ion-icon>
        </ion-button>
      </div>-->
      </div>
    </div>
    <div class="menu-card no-margin-start no-margin-end">
      <div>
        <div class="main-search-form">
          <div class="flex-container ion-justify-content-center">
            <ng-content select="[formComp]"></ng-content>
          </div>

          <!--experiences section starts-->
          <!--<app-b2b-experiences></app-b2b-experiences>-->
          <!--experiences section ends-->
        </div>
      </div>
      @if (selectedContainer?.feature?.type === featureTypes.SHORTSTAY) {
        <div class="switch-btn">
          <div class="switchBtn" (click)="gotoExtendedStay()" tapEffect>
            Switch to multiple night booking
            <span class="right-arrow"></span>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<div class="promoBox">
  <div class="flexBox">
    <a class="infoBox" [routerLink]="'/buy-gift-cards-online'" target="_blank" tapEffect [effectType]="'list-item'">
      <div class="box">
        <div class="promoImg">
          <img
            ngSrc="https://static-img.bag2bag.in/new-assets/india/new-app/icons/gift-cards-badge.png?&format=webp&quality=100"
            alt="gift-card" width="128" height="128">
        </div>
        <div class="title">Buy Gift Cards</div>
      </div>
    </a>
    <a class="infoBox" [routerLink]="'/rewards/free-stays'" target="_blank" tapEffect [effectType]="'list-item'">
      <div class="box">
        <div class="promoImg">
          <img
            ngSrc="https://static-img.bag2bag.in/new-assets/india/new-app/icons/free-stay-badge.png?&format=webp&quality=100"
            alt="gift-card" width="128" height="128">
        </div>
        <div class="title">11th Free Stay</div>
      </div>
    </a>
    <a class="infoBox" [routerLink]="'/membership'" target="_blank" tapEffect [effectType]="'list-item'">
      <div class="box">
        <div class="promoImg">
          <img
            ngSrc="https://static-img.bag2bag.in/new-assets/india/new-app/icons/membership-icon-badge.png?&format=webp&quality=100"
            alt="gift-card"
            width="128" height="128">
        </div>
        <div class="title">Bag2Bag Membership</div>
      </div>
    </a>
    <a class="infoBox" [routerLink]="'/promos/share-and-earn'" target="_blank" tapEffect [effectType]="'list-item'">
      <div class="box">
        <div class="promoImg">
          <img
            ngSrc="https://static-img.bag2bag.in/new-assets/india/new-app/icons/share-earn-badge.png?&format=webp&quality=100"
            alt="gift-card" width="128" height="128">
        </div>
        <div class="title">Share and Earn</div>
      </div>
    </a>
    <!--<a class="infoBox">
      <div></div>
      <div>Membership</div>
    </a>-->
  </div>
</div>

<!--<app-desktop-promo></app-desktop-promo>-->

